exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer{background-color:#fff;padding:1rem 0;text-align:left;font-size:16px}.footer .row{padding:5px}.footer .row img{margin:25px}.footer small button{top:-1px}.footer small button .MuiButton-label{font-size:inherit}.footer .covr{color:#0000cd}.footer button .MuiButton-label{text-transform:none;font-size:16px}.footer .links{max-width:1200px;margin:auto}@media screen and (min-width: 768px){.footer .links .colSetting{padding:3px !important;width:max-content !important}.footer .links .colSetting span.MuiButton-label{width:max-content !important}.footer .links .colSetting .col-sm{width:max-content !important}}.footer .aflacFont{font-size:15px}.footer .aflac-font{font-size:13pt}.footer .disclaimer{display:inline-block;text-align:left}.MuiDialog-root .text-btn-link{padding:0px !important;vertical-align:initial;min-width:auto}a.term-condition-link{cursor:pointer;text-decoration:none}a.term-condition-link:hover,span.term-link-color{color:#007bff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Footer/Footer.scss
// module id = 7073
// module chunks = 11